var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPencil = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70564 22.3603L0.960283 24.5362L3.1362 17.7909L7.70564 22.3603Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94603 20.4101L5.09964 15.5637L16.7059 3.95745L21.5523 8.80383L9.94603 20.4101Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.109 0.955362L24.5409 4.3872C24.9335 4.77983 24.9335 5.35693 24.5409 5.74956L23.6146 6.67588L18.8204 1.88168L19.7467 0.955362C20.1393 0.562731 20.7164 0.562731 21.109 0.955362Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPencil, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pencil.b51c890c.svg";
export { ForwardRef as ReactComponent };